"use client";

import { Card, CardContent, CardHeader, Grid } from "@mui/material";

import { PasswordResetUser } from "@/types/passwordReset";

import { usePasswordReset } from "@/context/passwordReset";
import { useRecaptcha } from "@/context/util/recaptcha";
import { useSecuritySettings } from "@/context/util/securitySettings";

import PasswordForm from "@/components/password/form";
import QuestionForm from "@/components/question/form";

export default function ResetForm() {
  const { showV2 } = useRecaptcha();
  const { questions } = useSecuritySettings();
  const { errors, passwordResetUser, setErrors, setPasswordResetUser } =
    usePasswordReset();

  return (
    <Grid container justifyContent="center" spacing={2} mt={2}>
      {passwordResetUser?.token && (
        <Grid
          key="security-settings-grid"
          size={{ xs: 12, md: 6 }}
          mb={2}
          sx={{ display: "flex", flexDirection: "column", padding: 0 }}
        >
          <Card sx={{ flexGrow: 1 }}>
            <CardHeader
              title="Set Security Settings"
              slotProps={{ title: { fontWeight: "bold", color: "primary" } }}
            />
            <CardContent sx={{ flexGrow: 1 }}>
              <QuestionForm<PasswordResetUser>
                entity={passwordResetUser}
                errors={errors}
                questions={questions}
                set={setPasswordResetUser}
                setErrors={setErrors}
                showV2={showV2}
              />
            </CardContent>
          </Card>
        </Grid>
      )}
      <Grid
        key="password-reset-grid"
        size={{ xs: 12, md: passwordResetUser?.token ? 6 : 8 }}
        mb={2}
        sx={{ display: "flex", flexDirection: "column", padding: 0 }}
      >
        <Card sx={{ flexGrow: 1 }}>
          <CardHeader
            title="Set Password"
            slotProps={{ title: { fontWeight: "bold", color: "primary" } }}
          />
          <CardContent sx={{ flexGrow: 1 }}>
            <PasswordForm<PasswordResetUser>
              entity={passwordResetUser}
              errors={errors}
              setErrors={setErrors}
              set={setPasswordResetUser}
            />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
